import { Directive,HostBinding,OnInit,ElementRef,Renderer2,Input,Inject } from '@angular/core';

@Directive({
	selector: '[abs-skip-content]'
})
export class AbsSkipContentDirective implements OnInit {
	focusListener;
	focusOutListener;
	@HostBinding('style.z-index') containerZIndex:string = '-1';
	@HostBinding('style.opacity') containerOpacity:string = '0.9';
	constructor(
		@Inject(ElementRef) private el:ElementRef,
		@Inject(Renderer2) private renderer:Renderer2
	) { }
	ngOnInit() {
		const skipContent = this.el.nativeElement.querySelector('[skip-content-trigger]');
		this.renderer.setStyle(skipContent, 'opacity', '0');
		this.focusListener = this.renderer.listen(skipContent,'focus',this.focusHandler.bind(this));
		this.focusOutListener = this.renderer.listen(skipContent,'focusout',this.focusOutHandler.bind(this));
	}
	focusHandler(e) {
		this.containerZIndex = '1';
		this.renderer.setStyle(e.target, 'opacity', '1');
	}
	focusOutHandler(e) {
		this.containerZIndex = '-1';
		this.renderer.setStyle(e.target, 'opacity', '0');
	}
}
